import { Card, Badge, Button } from "react-bootstrap";
import { User, Video, VideoOff } from "lucide-react";

export const UserPanel = ({
  videoRef,
  videoOn,
  onVideoToggle,
  speaking
}) => {
  return (
    <Card className="h-100">
      <Card.Body>

        {videoOn ? (
          <div className="ratio ratio-16x9 bg-dark rounded mb-3 overflow-hidden">
            <video
              ref={videoRef}
              autoPlay
              muted
              playsInline
              className="w-100 h-100 object-fit-cover"
            />

          </div>
        ) : (
          <div className="ratio ratio-16x9 bg-light rounded mb-3 d-flex align-items-center justify-content-center">
            <User size={64} className="text-secondary" />
          </div>
        )}

        <div className="d-flex justify-content-between align-items-center">
          <div>
            <User size={18} /> You{" "}
            {speaking && <Badge bg="success">Speaking</Badge>}
          </div>

          <Button
            variant={videoOn ? "danger" : "secondary"}
            size="sm"
            onClick={onVideoToggle}
          >
            {videoOn ? <VideoOff size={16} /> : <Video size={16} />}
          </Button>
        </div>

      </Card.Body>
    </Card>
  );
};
